import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { verifyRegistrationEmail } from '../../../slices/userSlice';

const VerifyEmailAction = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      dispatch(verifyRegistrationEmail(token)).then((result) => {
        if (verifyRegistrationEmail.fulfilled.match(result)) {
          toast.success("Account verified! You can now log in.");
          navigate("/login");
        } else {
          toast.error("Verification expired! Try again.");
        }
      });
    }
  }, [dispatch, token, navigate]);

  return <div>Verifying your account...</div>;
};
export default VerifyEmailAction;